import { useVerificationFlow } from '../../VerificationFlowContext'
import { defineMessages, useIntl } from 'react-intl'
import { useEffect } from 'react'
import { useToast } from '@homebotapp/hb-react-component-catalog'
import { useSendMessageStep } from '../../../../../hooks/homebotNetwork/verificationFlow/useSendMessageStep'

const MSG = defineMessages({
  success: {
    id: 'SendMessageView.success',
    defaultMessage: 'Message sent successfully!'
  },
  error: {
    id: 'SendMessageView.error',
    defaultMessage: 'Failed to send message. Please try again.'
  }
})

/**
 * SendMessageView Component
 *
 * Allows users to compose and send a message to their partner.
 * Handles the messaging state in the verification flow.
 */
const SendMessageView = () => {
  const { state } = useVerificationFlow()
  const { message } = state
  const intl = useIntl()
  const toast = useToast()
  const { sendMessage } = useSendMessageStep()

  // Handle send message when message is available
  useEffect(() => {
    const handleSendMessage = async () => {
      if (!message) return

      try {
        await sendMessage(message)
        toast({
          description: intl.formatMessage(MSG.success),
          status: 'success'
        })
      } catch (error) {
        toast({
          description: intl.formatMessage(MSG.error),
          status: 'error'
        })
      }
    }

    handleSendMessage()
  }, [message, sendMessage, toast, intl])

  return null
}

export default SendMessageView
